import { AccessConfig } from "../../model/BookingModel";
import { IEmployee } from "../../model/LoginModel";
import { SessionStorage } from "../../services/storage";
import { CountryEnum, Employee, isProdMode, UserEnum } from "../../utils/app-common";


//TODO: Need to change the logic of this fuc. Have to follow S.O.L.I.D principle
export const AuthenticationHook = (access: number[], country: number[], isEmployee: boolean = false) => {
	const session = SessionStorage.get('employee') ?? '{}';
	const employeeDetail: IEmployee = JSON.parse(session);
	const { positionId, employeeId, countryId, isSalesperson } = employeeDetail ?? {};

	if (UserEnum.ADMIN === positionId) {
		return { isAllowed: true };
	}
	if (isEmployee) {
		if (access?.some(role => employeeId === role)) {
			return { isAllowed: true };
		}
	} else {
		const isCountryAllowed = country?.some(country => countryId === (country));
		const isPositionAllowed = access?.some(role => positionId === (role));
		const isSalesPersonAllowed = isSalesperson && access.includes(UserEnum.SALES_PERSON);
		const isAllowed = (isPositionAllowed && isCountryAllowed) || isSalesPersonAllowed;
		return { isAllowed };
	}
	return { isAllowed: false };

}


export const NewAuthenticationHook = (access: AccessConfig) => {
	const session = SessionStorage.get("employee") ?? "{}";
	const employeeDetail: IEmployee = JSON.parse(session);

	const {
		employeeId,
		positionId,
		countryId,
		isSalesperson
	} = employeeDetail ?? {};
	if (UserEnum.ADMIN === positionId) {
		return { isAllowed: true };
	}
	if (isProdMode() && (employeeId === Employee?.MATEEN_PROD)) {
		return { isAllowed: true }
	}
	if (!isProdMode() && (employeeId === Employee?.MATEEN_DEV)) {
		return { isAllowed: true }
	}


	const {
		employeeIds = [],
		positionIds = [],
		countries = [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE]
	} = access;

	// 1️⃣ Employee override
	if (
		typeof employeeId === "number" &&
		employeeIds.includes(employeeId)
	) {
		return { isAllowed: true };
	}

	// 2️⃣ Position + country
	const isPositionAllowed =
		typeof positionId === "number" &&
		positionIds.includes(positionId);

	const isCountryAllowed =
		typeof countryId === "number" &&
		countries.includes(countryId);

	// 3️⃣ Salesperson override
	const isSalesPersonAllowed =
		isSalesperson === true &&
		positionIds.includes(UserEnum.SALES_PERSON);

	const isAllowed =
		(isPositionAllowed && isCountryAllowed) || isSalesPersonAllowed;

	return { isAllowed };
};


